/* eslint-disable no-unused-expressions */
import React from "react";

import PropTypes from "prop-types";
import Link from "~hooks/link";

import styles from "./breadcrumbs.module.scss";
import keygen from "~helpers/keygen";
import { excludeTemplates } from "../../../constants/excluded.mjs";
import useTranslate from "~hooks/useTranslate/useTranslate";

function Breadcrumbs({
  page,
  separator = <span aria-hidden="true"> / </span>,
  markets,
}) {
  const activeMarket = markets && markets[page.market];
  const breadcrumbAriaLabel = useTranslate(
    "ariaLabel-breadcrumb",
    "Breadcrumb"
  );
  const getTranslationArray = () => {
    const translationArray = ["Home", `home_${page.type}`];
    page?.categories?.length && translationArray.push(`home_${page.template}_${page.categories[0].short_name}`);
    return translationArray;
  };

  const homeTranslation = useTranslate(getTranslationArray().reverse(), "Home");

  if (
    page.path ===
    `${
      activeMarket && activeMarket.path_prefix
        ? `${activeMarket.path_prefix}`
        : "/"
    }`
  ) {
    return <></>;
  }
  const isExcludedTemplate = excludeTemplates.includes(page?.template);

  return (
    <ol className={styles.breadcrumbs || ""} aria-label={breadcrumbAriaLabel}>
      <li className={styles.item || ""}>
        {isExcludedTemplate ? (
          homeTranslation
        ) : (
          <Link
            to={(activeMarket && activeMarket.path_prefix) || "/"}
            title="Home"
            className="breadcrumbs-gtm"
          >
            {homeTranslation}
          </Link>
        )}

        {separator}
      </li>
      {page.breadcrumbs &&
        page.breadcrumbs.map((breadcrumb) => (
          <li key={keygen()} className={styles.item}>
            {breadcrumb.path ? (
              <Link
                to={breadcrumb.path}
                title={breadcrumb.label}
                className="breadcrumbs-gtm"
              >
                {breadcrumb.label}
              </Link>
            ) : (
              breadcrumb.label
            )}
            {separator}
          </li>
        ))}
      <li aria-current="page" className={styles.item || ""}>
        {page.vanity_label ? page.vanity_label : page.title}
      </li>
    </ol>
  );
}

Breadcrumbs.propTypes = {
  markets: PropTypes.shape({
    path_prefix: PropTypes.string,
  }),
  page: PropTypes.shape({
    market: PropTypes.string,
    categories: PropTypes.arrayOf(
      PropTypes.shape({
        short_name: PropTypes.string,
      })
    ),
    title: PropTypes.string,
    path: PropTypes.string,
    breadcrumbs: PropTypes.arrayOf(PropTypes.shape({})),
    vanity_label: PropTypes.string,
    translations: PropTypes.shape({}),
    template: PropTypes.string,
    type: PropTypes.string,
  }).isRequired,
  separator: PropTypes.element,
};

export default Breadcrumbs;
